export const unitConstModel = {
    NumberUnitTypeId: "4",
    weightUnitTypeId: "2",
    volumnUnitTypeId: "3",
    areaUnitTypeId: "1",


  };


  export const productTypeConstModel = {
    finishProductId: "8",
    seedProductId: "5",
    packagingProductId: "9",
     
  };
  
  
   